import { apiServer } from 'settings/web-services/api';

export function getMlsDashboardStats() {
  return apiServer.get('/admin-panel/mls/dashboard');
}

export function getMlsStats(mlsId, cfg) {
  return apiServer.get(`/admin-panel/mls/stats/${mlsId}`, { params: cfg });
}
